/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Schedule } from '@src/app/model/schedule';
import { Field } from '@src/app/shared/field/Field';
import { IFormAction, ActionColor } from '@src/app/shared/form/form.component';

/** The charge type is locked on a saved schedule, because changing it silently re-apportions
 * every unit - and on a custom schedule throws away portions that cannot be derived again.
 * This unlocks the field, and nothing else, so it takes a deliberate act and a confirmation.
 */
export class ChangeChargeTypeAction implements IFormAction {
    name = $localize`Change Charge Type`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'lock_open';
    approvalNeeded = true;
    disabled = false;
    approvalText = '';
    tipText = $localize`Unlock the charge type so that it can be changed`;

    constructor(private chargeTypeField: Field) { }

    action() {
        this.chargeTypeField.enableControl();
        return null;
    }

    /** Only offered on a saved schedule - a new one has the field editable already. */
    setup(schedule: Schedule) {
        this.show = !!schedule?.id;
        this.approvalText = schedule?.chargeTypeId === Schedule.chargeId.custom
            ? $localize`This is a custom schedule. Its portions were entered by hand or imported,
                and they cannot be worked out again. If you change the charge type that data will
                be lost. Are you sure you want to proceed?`
            : $localize`Do you want to change the charge type? Click OK to make the charge type
                editable, or Cancel if that is not what you intended.`;
    }
}
